import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { Route, Routes } from "react-router-dom";
import { usePermission } from "../account/AccountStore";
import CreateMatch from "./CreateMatch";
import MatchesIndex from "./MatchesIndex";
import MatchProfile from "./MatchProfile";

const plus = <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>;
const edit = <FontAwesomeIcon icon={["fad", "pencil"]}></FontAwesomeIcon>;
const idBadge = <FontAwesomeIcon icon={["fad", "id-badge"]}></FontAwesomeIcon>;

const MatchesManagement = () => {
    const hasWritePermission = usePermission("sport:matches.write");
    return (
        <div>
            <Routes>
                <Route path={"create"} element={<>{hasWritePermission && <CreateMatch />}</>}></Route>
                <Route path={":id/*"} element={<MatchProfile />}></Route>
                <Route path={""} element={<MatchesIndex></MatchesIndex>}></Route>
            </Routes>
        </div>
    );
};

export default MatchesManagement;
